function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8fcfc;\n        fill-rule: evenodd;\n        filter: url(#filter);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
  id: "filter",
  x: 11825,
  y: 2283.09,
  width: 17.2,
  height: 20.85,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  result: "flood",
  floodColor: "#3d6d75"
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite",
  operator: "in",
  in2: "SourceGraphic"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend",
  in2: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M11839.9,2283.1h-8.8a2.355,2.355,0,0,0-2.3,2.31v0.28h-1.5a2.29,2.29,0,0,0-2.3,2.31v13.63a2.284,2.284,0,0,0,2.3,2.31h8.8a2.348,2.348,0,0,0,2.3-2.31v-0.28h1.5a2.284,2.284,0,0,0,2.3-2.31v-13.63A2.29,2.29,0,0,0,11839.9,2283.1Zm-3,18.53a0.833,0.833,0,0,1-.8.82h-8.8a0.833,0.833,0,0,1-.8-0.82V2288a0.841,0.841,0,0,1,.8-0.82h8.8a0.841,0.841,0,0,1,.8.82v13.63h0Zm3.8-2.59a0.833,0.833,0,0,1-.8.82h-1.5V2288a2.355,2.355,0,0,0-2.3-2.31h-5.8v-0.28a0.841,0.841,0,0,1,.8-0.82h8.8a0.841,0.841,0,0,1,.8.82v13.63h0Z",
  transform: "translate(-11825 -2283.09)"
});

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.2,
    height: 20.85,
    viewBox: "0 0 17.2 20.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.11c46d65.svg";
export { ForwardRef as ReactComponent };